import Text from '@/common/components/atom/text/text';
import { doctorSlugFromSearchHit, useRaviCardRate } from '@/modules/profile/hooks/useDoctorRateDetails';
import SearchCard from '@/modules/search/components/card/card';

export const SubstituteDoctorSuggestion = ({ doctor, groupName, onSelect, hideBanner = false }: { doctor: any; groupName?: string; onSelect: (element: 'card' | 'button') => void; hideBanner?: boolean }) => {
  const raviRate = useRaviCardRate(doctorSlugFromSearchHit(doctor));
  return <div className="flex flex-col mb-2 space-y-2">
            {!hideBanner && <div className="p-3 bg-green-600 border-green-700 text-white rounded-md border flex flex-col space-y-1">
              <Text className="text-sm font-medium">همین امروز با {groupName ? `متخصص ${groupName}` : 'پزشک'} آنلاین مشورت کنید</Text>
              <Text className="text-xs">بدون رفت‌وآمد و صف · پیگیری در همان گفت‌وگو</Text>
            </div>}
            <div onClick={event => { if (!(event.target as HTMLElement).closest('button')) onSelect('card'); }}>
              <SearchCard
                avatarSize="lg"
                baseInfo={{
                  displayName: doctor.title,
                  expertise: doctor.display_expertise,
                  isVerify: true,
                  avatar: doctor.image,
                  rate: raviRate,
                  isOnline: true,
                }}
                type="doctor"
                className="shadow-none !py-0 lg:!py-0 cursor-pointer"
                actions={[
                  {
                    text: `ویزیت آنلاین با دکتر ${doctor.title}`,
                    outline: false,
                    description: '',
                    action() {
                      onSelect('button');
                    },
                  },
                ]}
              />
            </div>
  </div>;
};
